import { useEffect, useState } from "react";
import api from "@/lib/apiClient";
import { waLink } from "@/lib/modules";
import { MessageCircle } from "lucide-react";

export function SupportButton() {
  const [phone, setPhone] = useState("");

  useEffect(() => {
    api.get("/support/phone").then((r) => setPhone(r.data.support_phone || "")).catch(() => {});
  }, []);

  if (!phone) return null;
  const link = waLink(phone, "Olá! Preciso de ajuda / atendimento da Aprisco Church — Zona Norte.");
  if (!link) return null;

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-[hsl(var(--emerald))] text-white shadow-lg px-4 py-3 hover:scale-105 transition-transform"
      data-testid="floating-support-button"
      title="Suporte via WhatsApp"
    >
      <MessageCircle className="h-5 w-5" />
      <span className="hidden sm:inline text-sm font-medium">Suporte</span>
    </a>
  );
}
